import {
  trackPerformanceItineraryRequested,
  trackPerformanceItineraryReceived,
  trackPerformanceItineraryRendered,
  trackPerformanceItineraryTotalTimeToRender,
  trackPerformanceHotelListRequested,
  trackPerformanceHotelListReceived,
  trackPerformanceHotelListRendered,
  trackPerformanceHotelListTotalTimeToRender,
  trackPerformanceActivityListRequested,
  trackPerformanceActivityListReceived,
  trackPerformanceActivityListRendered,
  trackPerformanceActivityListTotalTimeToRender,
} from '@libs/feature-toggle';
import {
  measureFirstItineraryRenderPerformance,
  measureHotelSelectionListRenderPerformance,
  measureActivitySelectionListRenderPerformance,
} from '@libs/utils';

export function trackPerformance(): void {
  measureFirstItineraryRenderPerformance().then(
    ({
      timeToFirstItineraryAvailabilityRequestMs,
      timeToFirstItineraryAvailabilityReceivedMs,
      timeToFirstItineraryRenderedMs,
      totalTimeRequiredToRenderFirstItinerary,
    }) => {
      trackPerformanceItineraryRequested(
        timeToFirstItineraryAvailabilityRequestMs
      );
      trackPerformanceItineraryReceived(
        timeToFirstItineraryAvailabilityReceivedMs
      );
      trackPerformanceItineraryRendered(timeToFirstItineraryRenderedMs);
      trackPerformanceItineraryTotalTimeToRender(
        totalTimeRequiredToRenderFirstItinerary
      );
    }
  );

  measureHotelSelectionListRenderPerformance().then(
    ({
      timeToHotelSelectionViewAvailabilityRequestMs,
      timeToHotelSelectionViewAvailabilityReceivedMs,
      timeToHotelSelectionListRenderedMs,
      totalTimeRequiredToRenderHotelSelectionList,
    }) => {
      trackPerformanceHotelListRequested(
        timeToHotelSelectionViewAvailabilityRequestMs
      );
      trackPerformanceHotelListReceived(
        timeToHotelSelectionViewAvailabilityReceivedMs
      );
      trackPerformanceHotelListRendered(timeToHotelSelectionListRenderedMs);
      trackPerformanceHotelListTotalTimeToRender(
        totalTimeRequiredToRenderHotelSelectionList
      );
    }
  );

  measureActivitySelectionListRenderPerformance().then(
    ({
      timeToActivitySelectionViewAvailabilityRequestMs,
      timeToActivitySelectionViewAvailabilityReceivedMs,
      timeToActivitySelectionListRenderedMs,
      totalTimeRequiredToRenderActivitySelectionList,
    }) => {
      trackPerformanceActivityListRequested(
        timeToActivitySelectionViewAvailabilityRequestMs
      );
      trackPerformanceActivityListReceived(
        timeToActivitySelectionViewAvailabilityReceivedMs
      );
      trackPerformanceActivityListRendered(
        timeToActivitySelectionListRenderedMs
      );
      trackPerformanceActivityListTotalTimeToRender(
        totalTimeRequiredToRenderActivitySelectionList
      );
    }
  );
}
